import { COLORS } from "Consts";

export const user_notification_styles = {
  tab: {
    "& ≈": {
      color: COLORS.$euiColorMediumShade + "!important",
      fontWeight: "500!important",
    },
    "&.euiTab-isSelected .euiTab__content": {
      color: "var(--button-bg) !important;",
    },
  },
  tabs: {},
  message: {
    fontSize: "var(--fs13)",
    color: "var(--text)",
    paddingBottom: "8px",
    borderBottom: "0.5px solid var(--border-color)",
  },
  mark: {
    "&:hover": {
      cursor: "pointer",
      color: "#0c99f9",
    },
  },
};
